import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import { AIFC_ONBOARDING_STATE_KEYS } from '../../constants/onboarding-state/onboarding-afic-onboarding.ts';

import onboardingStateGetOnboardingStateQuery, {
	type onboardingStateGetOnboardingStateQuery$data,
	type onboardingStateGetOnboardingStateQuery$variables,
} from './__generated__/onboardingStateGetOnboardingStateQuery.graphql.ts';
import type { GraphQLError } from 'graphql';

export const preloadAIFCOnboardingStateForTopNav = (): Promise<{
	data: onboardingStateGetOnboardingStateQuery$data | null;
	errors?: ReadonlyArray<GraphQLError>;
	hasErrors: boolean;
}> => {
	return query<
		onboardingStateGetOnboardingStateQuery$data,
		onboardingStateGetOnboardingStateQuery$variables
	>({
		query: onboardingStateGetOnboardingStateQuery,
		variables: {
			key: Object.values(AIFC_ONBOARDING_STATE_KEYS),
		},
	});
};
